import React from "react";
import { Divider, Typography, useMediaQuery } from "@mui/material";

// Import local images
import Image1 from "./Images/1.png";
import Image2 from "./Images/2.png";
import Image3 from "./Images/3.png";
import Image4 from "./Images/4.png";
import Image5 from "./Images/5.png";
import Image6 from "./Images/6.png";

export default function IndustryReportPage() {
  const isSmallScreen = useMediaQuery("(max-width:768px)");

  const containerStyle = {
    backgroundColor: "#fff",
    fontFamily: "Arial, sans-serif",
    paddingTop: "50px",
  };

  const gridContainerStyle = {
    display: "grid",
    gridTemplateColumns: isSmallScreen ? "1fr" : "1fr 1fr", // responsive
    gap: "2px",
    margin: "0 auto",
    padding: "1px 12px",
  };

  const imageStyle = {
    width: "100%",
    height: "auto",
  };

  return (
    <div style={containerStyle}>
      {/* Heading */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="h3"
          sx={{
            color: "#05184A",
            fontWeight: "bold",
            textTransform: "uppercase",
            textAlign: "center",
          }}
        >
          TRENDING INDUSTRIES <br /> BY 2030
        </Typography>

        <Divider
          sx={{
            width: "140px",
            height: "3px",
            backgroundColor: "#6a58c6",
            margin: "12px auto 16px auto",
            borderRadius: "2px",
          }}
        />

        <Typography
          variant="body1"
          sx={{
            color: "#555",
            maxWidth: "500px",
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          Projections and growth prospects from <br />
          the vantage point of startups.
        </Typography>
      </div>

      {/* Responsive Images in Grid Layout */}
      <div style={gridContainerStyle}>
        <img src={Image1} alt="Trending Industries 1" style={imageStyle} />
        <img src={Image2} alt="Trending Industries 2" style={imageStyle} />
        <img src={Image3} alt="Trending Industries 3" style={imageStyle} />
        <img src={Image4} alt="Trending Industries 4" style={imageStyle} />
        <img src={Image5} alt="Trending Industries 5" style={imageStyle} />
        <img src={Image6} alt="Trending Industries 6" style={imageStyle} />
      </div>
    </div>
  );
}
